import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-work-grps',
  templateUrl: './work-grps.component.html',
  styleUrls: ['./work-grps.component.css']
})
export class WorkGrpsComponent implements OnInit {
    itemsListCapacityGroups: Item[] = [];

    constructor(private datatask: DataTaskService) {

    }

    private async loadCapacityGroups() {
        this.itemsListCapacityGroups = await this.datatask.Post(2020);
    }

    private async init() {
        this.loadCapacityGroups();
    }

    ngOnInit() {
        this.init();
    }
}
